var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex"}},_vm._l((_vm.days),function(day,index){return (
      typeof _vm.error_per_date[day.format_month_day] === 'object' &&
      Object.keys(_vm.error_per_date[day.format_month_day]).length > 0
    )?_c('div',{key:index},[_c('Exclamation-Triangle',{attrs:{"filterd_days_hope_holiday_error":_vm.error_per_date,"active_dialog":"hope_holiday"}})],1):_c('div',{staticStyle:{"margin-left":"42px"}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }